import { gql } from '@apollo/client';

export const COMPANY_FRAGMENT = gql`
  fragment CompanyFragment on StoreCompany {
    name
    url
    address
    postcode
    city
    country
    countryCode
    vat
    registrationNumber
    contactEmail
    contactPhone
    mid
    eori
    rex
    supportEmail
  }
`;
